import { get, post, del } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";
import {
    type CreateReportRequest,
    type CreateReportResponse,
    type ListReportsResponse,
    type ReportDownloadResponse,
} from "@/old/document/types/api";

const API_NAME = "Reporting API";
const BASE_PATH = "/api/v1";

/**
 * Create a new report
 */
// export async function createReport({
//     year,
//     reportType = "EXPENSES",
// }: CreateReportRequest): Promise<CreateReportResponse> {
//     try {
//         const session = await fetchAuthSession();
//         const token = session.tokens?.idToken?.toString();

//         const response = await post({
//             apiName: API_NAME,
//             path: `${BASE_PATH}/reports`,
//             options: {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//                 body: { year, reportType },
//             },
//         }).response;

//         const data = await response.body.json();
//         return data as unknown as CreateReportResponse;
//     } catch (error) {
//         console.error("Error creating report:", error);
//         throw error;
//     }
// }

/**
 * Create a new report with support for monthly/annual periods and CSV/archive formats
 */
export async function createReport({
    year,
    month,
    period,
    format,
    reportType = "EXPENSES",
    forceRecreate = false,
}: CreateReportRequest): Promise<CreateReportResponse> {
    try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        const response = await post({
            apiName: API_NAME,
            path: `${BASE_PATH}/reports`,
            options: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: {
                    year,
                    period,
                    format,
                    reportType,
                    forceRecreate,
                    ...(month && { month }),
                },
            },
        }).response;

        const data = await response.body.json();
        return data as unknown as CreateReportResponse;
    } catch (error) {
        console.error("Error creating report:", error);
        throw error;
    }
}

/**
 * List reports with optional filtering
 */
export async function listReports(params?: {
    year?: string;
    reportType?: "EXPENSES";
}): Promise<ListReportsResponse> {
    try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        const queryParams = new URLSearchParams();
        if (params?.year) queryParams.append("year", params.year);
        if (params?.reportType)
            queryParams.append("reportType", params.reportType);

        const queryString = queryParams.toString()
            ? `?${queryParams.toString()}`
            : "";

        const response = await get({
            apiName: API_NAME,
            path: `${BASE_PATH}/reports${queryString}`,
            options: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        }).response;

        const data = await response.body.json();
        return data as unknown as ListReportsResponse;
    } catch (error) {
        console.error("Error listing reports:", error);
        throw error;
    }
}

/**
 * Get download URL for a report
 */
export async function getReportDownloadUrl(
    reportId: string,
): Promise<ReportDownloadResponse> {
    try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        const response = await get({
            apiName: API_NAME,
            path: `${BASE_PATH}/reports/${reportId}/download`,
            options: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        }).response;

        const data = await response.body.json();
        return data as unknown as ReportDownloadResponse;
    } catch (error) {
        console.error(
            `Error getting download URL for report ${reportId}:`,
            error,
        );
        throw error;
    }
}

/**
 * Delete a report - COMMENTED OUT TO PREVENT RATE LIMIT CIRCUMVENTION
 */
// export async function deleteReport(
//     reportId: string
// ): Promise<{ message: string; reportId: string }> {
//     try {
//         const session = await fetchAuthSession();
//         const token = session.tokens?.idToken?.toString();

//         await del({
//             apiName: API_NAME,
//             path: `${BASE_PATH}/reports/${reportId}`,
//             options: {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             },
//         }).response;

//         return {
//             message: "Report deleted successfully",
//             reportId,
//         };
//     } catch (error) {
//         console.error(`Error deleting report ${reportId}:`, error);
//         throw error;
//     }
// }
